// extracted by mini-css-extract-plugin
export default {"termsOfService":"TermsOfService_termsOfService__RnLjr","tos-section":"TermsOfService_tos-section__-OSp5","tos-section-title":"TermsOfService_tos-section-title__gYf52"};